module.exports = __webpack_public_path__ + "static/media/protocols.dcd150a6.svg";